'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  display: block;\n  max-width: 100%;\n'], ['\n  display: block;\n  max-width: 100%;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _UIImage = require('UIComponents/image/UIImage');

var _UIImage2 = _interopRequireDefault(_UIImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents2.default.div.withConfig({
  displayName: 'ImageAttachment__Wrapper'
})(_templateObject);

var ImageAttachment = function (_React$Component) {
  _inherits(ImageAttachment, _React$Component);

  function ImageAttachment() {
    _classCallCheck(this, ImageAttachment);

    return _possibleConstructorReturn(this, (ImageAttachment.__proto__ || Object.getPrototypeOf(ImageAttachment)).apply(this, arguments));
  }

  _createClass(ImageAttachment, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          name = _props.name,
          onLoad = _props.onLoad,
          url = _props.url;


      return _react2.default.createElement(
        Wrapper,
        null,
        _react2.default.createElement(_UIImage2.default, { alt: name, src: url, onLoad: onLoad })
      );
    }
  }]);

  return ImageAttachment;
}(_react2.default.Component);

ImageAttachment.propTypes = {
  name: _react.PropTypes.string.isRequired,
  onLoad: _react.PropTypes.func,
  url: _react.PropTypes.string.isRequired
};

exports.default = ImageAttachment;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.5219/js/components/attachments/ImageAttachment.js
// module id = 1136
// module chunks = 2 3